
import Cookies from "js-cookie";
import { useState } from "react";
import { ROUTES } from "./Routes";
import { createModal } from "../hooks/createModal";
import ApiSelector from "./ApiSelector";
export default function LiveToggle() {


    const [isLive, setIsLive] = useState((Cookies.get("l") === "true") || false);

    const [visible, setVisible] = useState(false);

    // Don't show toggle in production
    let mode = process.env.REACT_APP_API || 'inherit';
    if (mode === "live" || mode === "staging") {
        return (<></>);
    }


    const options = [
        { label: "unset", value: "" },
        { label: "tbraun", value: "https://tbraunapi.bookmanager.com/" },
        { label: "eric", value: "https://ericapi.bookmanager.com/" },
        { label: "atoth", value: "https://atothapi.bookmanager.com/" },
        { label: "mike", value: "https://mikeapi.bookmanager.com/" },
        { label: "dev", value: "https://devapi.bookmanager.com/" },
        { label: "staging", value: "https://stagingapi.bookmanager.com/" },
        { label: "live", value: "https://api.bookmanager.com/" },
    ]



    let _style = {
        boxShadow: "0px 2px 3px 1px #333",
        width: "30px",
        position: "fixed",
        zIndex: "2000",
        top: "-1px",
        right: "20px",

        borderBottomLeftRadius: "3px",
        borderBottomRightRadius: "3px",
        cursor: "pointer",
        margin: "0 auto"
    }

    const onConfirm = (item) => {
        Cookies.set("l", "true")
        Cookies.set("api", item);
        setIsLive(true);
        window.location.reload();
    }

    const onCancel = (item) => {
        Cookies.set("l", "false")
        Cookies.set("api", item);
        setIsLive(false);
        window.location.reload();
    }

    const title = Cookies.get("api") || "Not set";



    const drawSelector = () => {
        let _route = window.bm_state.value;
        window.bm_state.value = ROUTES.MISC.SELECTOR;
        createModal({
            offset: [0, -130],
            title: "Select API & Database",
            component: <ApiSelector route={ROUTES.MISC.SELECTOR} />, closable: true, callback: (e) => {
                window.bm_state.value = _route;
                if (e) {

                }
            }
        })
    }

    return (
        <div onClick={() => drawSelector()} style={_style} >
            <div className="shim" />
            <div style={{ "border": "none", "color": (isLive) ? "#34c934" : "gray", "textAlign": "center" }}>&bull;</div>
            <div className="shim" />
        </div>
    )
}